export default "__VITE_ASSET__BKF$nlok__"